import {DisplayOption} from '@/components/interfaces/ComponentOptions';
import {FieldType} from '@/custom-forms/admin/FormModels';
import {DateTime} from 'luxon';

export interface NewsShow {
    id: string;
    name: string;
    shortDescription: string;
    fullDescription: string;
    talentDescription: string;
    newsImageUrl: string;
    socialShareImageUrl: string;
    active: boolean;
    redirectAlias: string;
    discontinued: boolean;
}

export interface NewsShowArchive {
    id: string;
    newsShowId: string;
    broadcastedLiveOn: string;
    replayArchiveUrl?: string;
    archiveThumbnailUrl?: string;
    title: string;
    briefDescription: string;
    fullDescription: string;
    expanded: boolean;
    isNew: boolean;
    publishAt: string;
    useSwarmify: boolean;
    vimeoUrl?: string;
    rumbleUrl?: string;
    bitchuteUrl?: string;
    swarmifyProcessed: boolean;
    videoTotalTime?: string;
    videoSegments: VideoSegment[];
    pageBuilt: boolean;
    urlSuffix: number;
    showSuffix: boolean;
    newsShowArchivePageUrl?: string;
    newsShowPageUrl?: string;
}

export interface VideoSegment {
    id: string;
    description: string;
    time: string;
    newsShowArchiveId: string;
}

export interface NewsShowArchiveThumnailUrl {
    id: string;
    newsShowId: string;
    archiveThumbnailUrl?: string;
}

export interface NewsShowArchiveFileUrl {
    id: string;
    newsShowId: string;
    replayArchiveUrl?: string;
}

export interface NewsShowSocialMedia {
    id: string;
    newsShowId: string;
    socialMediaType: SocialMediaType;
    url: string;
    expanded: boolean;
    isNew: boolean;
}

export enum SocialMediaType {
    TWITTER= 'TWITTER',
    FACEBOOK= 'FACEBOOK',
    INSTAGRAM= 'INSTAGRAM',
    LINKED_IN= 'LINKED_IN',
    YOUTUBE= 'YOUTUBE',
}

export const SocialMediaTypeOptions: DisplayOption[] = [
    {id: SocialMediaType.TWITTER, name: 'Twitter'},
    {id: SocialMediaType.FACEBOOK, name: 'Facebook'},
    {id: SocialMediaType.INSTAGRAM, name: 'Instagram'},
    {id: SocialMediaType.LINKED_IN, name: 'Linked In'},
    {id: SocialMediaType.YOUTUBE, name: 'YouTube'}
];
